import React from 'react';

const QuantityInput = ({ value = 0, onChange }) => {
    const v = Number(value || 0);

    return (
        <div
            className="w-75 quantity-editor d-flex align-items-center bg-white border rounded justify-content-between"
            onClick={(e) => e.stopPropagation()}
        >
            <button
                type="button"
                className="btn btn-sm border-0"
                onClick={() => onChange(Math.max(0, v - 1))}
            >
                -
            </button>

            <span className="quantity-value px-2">{v}</span>

            <button
                type="button"
                className="btn btn-sm border-0"
                onClick={() => onChange(v + 1)}
            >
                +
            </button>
        </div>
    );
};

export default QuantityInput;
